import type { UseQueryResult } from '@tanstack/react-query';
import {
  createProcessConversation,
  listProcessConversations,
} from '@api/processAssistant';
import { useScopedAssistantConversation } from '@hooks/useScopedAssistantConversation';

export const processAssistantConversationKey = (
  processId: string,
): readonly unknown[] => ['process-assistant-conversation', processId];

/**
 * The conversation the assistant panel talks in. The panel only mounts the
 * chat once the user opens it, so opening the editor mints nothing.
 */
export function useProcessAssistantConversation(
  processId: string | undefined,
): UseQueryResult<string, Error> {
  return useScopedAssistantConversation({
    queryKey: processAssistantConversationKey(processId ?? ''),
    enabled: Boolean(processId),
    list: () => listProcessConversations(processId!),
    create: () => createProcessConversation(processId!),
  });
}
